import { takeLatest, put, call } from 'redux-saga/effects';
// import { routerActions } from 'react-router-redux';
// import { push } from 'react-router-redux';
import { delay } from 'redux-saga';
// import Raven from 'raven-js';
import analyticsTracker from './analytics';
import history from '../root/history';

import api from './api';

function* ApiLogin(action) {
  console.log(`payload: ${action.payload}`);
  const { payload } = action;
  const handler = 'V3_LOGIN';
  const response = yield call(api, Object.assign(action, { payload, handler }));
  // const response = yield put({});
  const user = response.data.data;
  console.log('arunnnnn');
  console.log(user);
  yield put({ type: 'LOGIN_SUCCESS', user });
  yield call(delay, 2000);
  // yield put({ type: 'GET_WALLET_AMOUNT' });
  const userIDString = user.user.user_id.toString();
  window.FB.AppEvents.setUserID(userIDString);
  window.FB.AppEvents.logPageView();
  // Raven.setUserContext({
  //   id: userIDString,
  // });

  if (user && user.user && user.user.info && user.user.info.otp_verified) {
    localStorage.setItem('oldUser', true);
    yield put({ type: 'NAVIGATE', path: 'new' });
    // } else if (user && user.user && user.user.info && user.user.info.user_accepted) {
    //   yield put({ type: 'NAVIGATE', path: 'verifyProfile' });
  } else {
    analyticsTracker('fb', 'Sign Up - Initiated', 'userID', user.user.user_id);
    yield put({ type: 'NAVIGATE', path: 'createAccount' });
  }
}

function* ApiCall() {
  yield takeLatest('NOSTRA_API_CALL', api);
}

function* CompleteLogin() {
  yield takeLatest('SOCIAL_LOGIN_SUCCESS', ApiLogin);
}

// new api google login
function* NewApiLogin(action) {
  const { payload } = action;
  const handler = 'V4_UTILS_LOGIN';
  const response = yield call(api, Object.assign(action, { payload, handler }));
  const user = response.data;
  yield put({
    type: 'NEW_LOGIN_SUCCESS',
    user,
    token: user.login_token,
    payload,
  });
  yield call(delay, 2000);
  const userIDString = user && user.user_id ? user.user_id.toString() : '';
  if (process.env.REACT_APP_SC_ENV === 'production' && window.FB) {
    window.FB.AppEvents.setUserID(userIDString);
    window.FB.AppEvents.logPageView();
  }
  // Raven.setUserContext({
  //   id: userIDString,
  // });
  analyticsTracker('gtag', 'User Login', 'isNewUser', response.data.new_user);
  analyticsTracker('fb', 'User Login', 'isNewUser', response.data.new_user);
  if (user && user.mobile_verified) {
    localStorage.setItem('oldUser', true);
    yield put({ type: 'NAVIGATE', path: 'new' });
    // } else if (user && user.user && user.user.info && user.user.info.user_accepted) {
    //   yield put({ type: 'NAVIGATE', path: 'verifyProfile' });
  } else {
    yield put({ type: 'NAVIGATE', path: 'createAccount' });
  }
}

function* NewCompleteLogin() {
  yield takeLatest('NEW_SOCIAL_LOGIN_SUCCESS', NewApiLogin);
}

function Navigation(action) {
  // window.ga('send', 'pageview');
  if (action.path !== 'login') {
    // window.gtag('config', 'UA-65340625-19', {
    //   page_path: action.path,
    // });
    window.ga('set', 'page', action.path);
    window.ga('send', 'pageview');
  }

  history.push(action.path);
}

function* NavigationHandler() {
  yield takeLatest('NAVIGATE', Navigation);
}

function BackHandler() {
  history.goBack();
}
function Replacer(action) {
  history.replace(action.paths);
}

function* ReplaceHistory() {
  yield takeLatest('REPLACEURL', Replacer);
}

function* NavigateBack() {
  yield takeLatest('GO_BACK', BackHandler);
}

export default [
  ApiCall,
  CompleteLogin,
  NavigationHandler,
  NavigateBack,
  ReplaceHistory,
  NewCompleteLogin,
];



// WEBPACK FOOTER //
// ./src/utils/sagas.js